import { Space, Tooltip } from "antd";
import React, { memo } from "react";
import { useNavigate } from "react-router";
import { RoleToLinkMapper } from "../../utils/UrlUtils";
import { useReadMemory } from "../../generic/hooks/useReadMemory";
import MemoryType from "../../../service/memory/enum/MemoryType";
import SmartIcon from "../../../components/generic/genericIcon/SmartIcon";

const OrganizationTableActions = ({ organization, handleEditClick }) => {
  const user = useReadMemory(MemoryType.USER);
  const navigate = useNavigate();

  const navigateToOrganizationCreator = (id) => {
    navigate(
      `${RoleToLinkMapper(
        user?.jobTitle
      )}organization-creator?organizationId=${id}`
    );
  };

  return (
    <>
      <Space size={20}>
        <Tooltip title="Edit" placement="bottom">
          <>
            <SmartIcon
              iconKey="edit"
              handleIconClick={() => handleEditClick(organization?.id)}
            />
          </>
        </Tooltip>
        <Tooltip title="Manage Organization" placement="bottom">
          <>
            <SmartIcon
              iconKey="manage_organization"
              handleIconClick={() =>
                navigateToOrganizationCreator(organization.id)
              }
            />
          </>
        </Tooltip>
      </Space>
    </>
  );
};

export default memo(OrganizationTableActions);
